<template>
  <v-container fluid>
    <div class="text-h4 mb-5 mt-5">Packs de horas</div>
    <div class="mb-2">
      <span>
        Filtrando por
        <v-chip
          v-for="filtro in filtrosActivos"
          :key="filtro.value"
          outlined
          class="mr-2"
          close
          :color="filtro.color"
          @click:close="eliminarFiltro(filtro)"
          small
        >
          {{ filtro.text }}
        </v-chip>
      </span>
    </div>
    <v-card :loading="loading">
      <!-- BUSQUEDA Y AGRUPAR POR -->
      <v-card-title>
        <v-container>
          <v-row align="center">
            <v-col>
              <v-text-field
                v-model="buscarPacks"
                append-icon="mdi-text-box-search-outline"
                label="Buscar"
                single-line
                hide-details
                style="min-width: 10em"
                clearable
              ></v-text-field
            ></v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <!-- FIN BUSQUEDA Y AGRUPAR POR -->
      <v-data-table
        :headers="packsHeaders"
        :items="packs"
        sort-by="fechaRegistro"
        sort-desc
        :items-per-page="15"
        item-key="id"
        :search="buscarPacks"
      >
        <template v-slot:item.fechaRegistro="{ item }">
          <span>{{ formatDate(item.fechaRegistro) }}</span>
        </template>

        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Packs</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="crearPack()">
              Crear pack
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-icon class="mr-2" @click="editarPack(item)">
            mdi-file-document-edit-outline
          </v-icon>
        </template>
      </v-data-table>
      <!-- BOTON ABRIR FILTROS -->
      <v-speed-dial
        fixed
        direction="top"
        transition="slide-y-reverse-transition"
        style="bottom: 37px; right: 30px"
        ><template v-slot:activator>
          <v-btn color="teal lighten-1" dark fab @click="dialogFiltros = true">
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn></template
        >
      </v-speed-dial>
      <!-- FIN BOTON ABRIR FILTROS -->
      <!-- DIALOG FILTROS -->
      <v-dialog v-model="dialogFiltros" max-width="40em">
        <dialog-filtros
          ref="dialogFiltros"
          @actualizarFechaIni="actualizarFechaIni"
          @actualizarFechaFin="actualizarFechaFin"
          @actualizarClienteSeleccionado="actualizarClienteSeleccionado"
          @actualizarContratoSeleccionado="actualizarContratoSeleccionado"
          @actualizarBloqueadas="actualizarBloqueadas"
          @aplicarFiltros="aplicarFiltros"
          @cerrarDialogFiltros="cerrarDialogFiltros"
        ></dialog-filtros>
      </v-dialog>
      <!-- FIN DIALOG FILTROS -->

      <!-- DIALOG NUEVO PACK / EDITAR PACK -->
      <v-dialog v-model="dialogPacks" persistent max-width="80em">
        <dialog-packs
          :key="idPackSeleccionado"
          v-bind:title="dialogPacksTitle"
          v-bind:pack="packSeleccionado"
          @cerrarDialogPacks="cerrarDialogPacks"
          @insertarPack="insertarPack"
          @actualizarPack="actualizarPack"
          @eliminarPack="eliminarPack"
        ></dialog-packs>
      </v-dialog>
      <!-- FIN DIALOG NUEVO PACK / EDITAR PACK -->
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import DialogFiltros from "./DialogFiltros";
import DialogPacks from "./DialogPacks";
import formatearFecha from "../../mixins/formatearFecha";

import { mapActions } from "vuex";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
  components: {
    "dialog-filtros": DialogFiltros,
    "dialog-packs": DialogPacks,
  },
  mixins: [formatearFecha],
  /* Si se agrega filtro hay que:
   1) Crear el "data" para el funcionamiento normal
   2) incluirlo en el componente DialogFiltros (v-bind + prop)
   3) Realizar la lógica en el componente e inlcuirlo en "aplicarFiltros" 
      tanto del componente DialogFiltros como el actual (acordarse de revisar las actualizaciones en ambos componentes)
   4) Agregarlo al computed filtrosActivos (para los chips visuales)
   5) Agregar la opcion de eliminación del filtro en "eliminarFiltros"*/
  data() {
    return {
      fechaInicio: null,
      fechaFin: null,
      clienteSeleccionado: null,
      contratoSeleccionado: [],
      // packsSeleccionados: [],
      packs: [],
      packsHeaders: [
        {
          text: "Cliente",
          align: "start",
          filterable: true,
          sortable: true,
          value: "cliente",
          groupable: false,
        },
        {
          text: "Fecha",
          align: "start",
          filterable: true,
          sortable: true,
          value: "fechaRegistro",
          groupable: false,
        },
        {
          text: "Horas ponderadas",
          align: "start",
          filterable: true,
          sortable: true,
          value: "horasContratadas",
          groupable: false,
          visible: false,
        },
        {
          text: "Contrato",
          align: "start",
          filterable: true,
          sortable: true,
          value: "contrato.contrato",
          groupable: false,
          visible: false,
        },
        {
          text: "Comentarios",
          align: "start",
          filterable: true,
          sortable: true,
          value: "observaciones",
          groupable: false,
          visible: false,
        },
        {
          text: "Origen",
          align: "start",
          filterable: true,
          sortable: true,
          value: "nDoc",
          groupable: false,
          visible: false,
        },
        {
          text: "",
          filterable: false,
          sortable: false,
          value: "acciones",
        },
      ],
      dialogFiltros: false,
      dialogPacks: false,
      dialogPacksTitle: "",
      packSeleccionado: null,
      idPackSeleccionado: -1,
      buscarPacks: "",
      bloqueadas: false,
    };
  },
  methods: {
    ...mapActions(["setSnackbar"]),
    getPacks(filtros = {}) {
      this.packsSeleccionados = [];
      this.loading = true;
      let queryParams = {
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
        cliente_id: this.clienteSeleccionado
          ? this.clienteSeleccionado.value
          : null,
        contrato_id: filtros.contrato_id ? filtros.contrato_id : null,
        bloqueadas: this.bloqueadas ? 1 : 0,
      };
      axios
        .get("api/diariohoras", {
          params: queryParams,
        })
        .then((res) => {
          this.packs = this.contratoSeleccionado.length
            ? res.data.filter((pack) => {
                return this.contratoSeleccionado.some((contrato) => {
                  return contrato.value === pack.contrato_id;
                });
              })
            : res.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    actualizarBloqueadas(val) {
      this.bloqueadas = val;
    },
    actualizarFechaIni(val) {
      this.fechaInicio = val;
    },
    actualizarFechaFin(val) {
      this.fechaFin = val;
    },
    actualizarClienteSeleccionado(val) {
      this.clienteSeleccionado = val;
    },
    actualizarContratoSeleccionado(val) {
      this.contratoSeleccionado = val;
    },
    aplicarFiltros(val) {
      if (val) this.getPacks();
      this.cerrarDialogFiltros();
    },
    cerrarDialogFiltros() {
      this.dialogFiltros = false;
    },
    crearPack() {
      this.packSeleccionado = null;
      this.idPackSeleccionado = 0;
      this.dialogPacksTitle = "Nuevo pack";
      this.dialogPacks = true;
    },
    editarPack(item) {
      this.packSeleccionado = item;
      this.idPackSeleccionado = item.id;
      this.dialogPacksTitle = "Editar pack";
      this.dialogPacks = true;
    },
    cerrarDialogPacks() {
      this.dialogPacks = false;
    },
    insertarPack(pack) {
      console.log(pack);
      this.packs.push(pack);
    },
    actualizarPack(pack) {
      console.log(pack);
      let index = this.packs.findIndex(function (item) {
        if (item.id === pack.id) return true;
      });
      if (index != -1) {
        let deleted = this.packs.splice(index, 1, pack);
      }
    },
    eliminarPack(pack) {
      let index = this.packs.findIndex(function (item) {
        if (item.id === pack.id) return true;
      });
      if (index != -1) {
        let deleted = this.packs.splice(index, 1);
      }
    },
    eliminarFiltro(filtro) {
      switch (filtro.value) {
        case "fechaInicio": {
          this.eliminarFechaIni();
          break;
        }
        case "fechaFin": {
          this.eliminarFechaFin();
          break;
        }
        case "cliente": {
          this.eliminarClienteSeleccionado();
          break;
        }
        case "contrato": {
          this.contratoSeleccionado.splice(0, this.contratoSeleccionado.length);
          break;
        }
        case "bloqueadas": {
          this.eliminarBloqueadas();
          break;
        }
      }
    },
    eliminarFechaIni() {
      this.fechaInicio = null;
      this.actualizarDialogFiltrosFechaIni();
      this.aplicarFiltros(true);
    },
    actualizarDialogFiltrosFechaIni() {
      if (this.$refs.dialogFiltros) {
        this.$refs.dialogFiltros.actualizarFechaIni(this.fechaInicio);
      }
    },
    eliminarFechaFin() {
      this.fechaFin = null;
      this.actualizarDialogFiltrosFechaFin();
      this.aplicarFiltros(true);
    },
    actualizarDialogFiltrosFechaFin() {
      if (this.$refs.dialogFiltros) {
        this.$refs.dialogFiltros.actualizarFechaFin(this.fechaFin);
      }
    },
    eliminarClienteSeleccionado() {
      this.clienteSeleccionado = null;
      this.actualizarDialogFiltrosClienteSeleccionado();
      this.aplicarFiltros(true);
    },
    actualizarDialogFiltrosClienteSeleccionado() {
      if (this.$refs.dialogFiltros) {
        this.$refs.dialogFiltros.actualizarClienteSeleccionado(
          this.clienteSeleccionado
        );
      }
    },
    eliminarBloqueadas() {
      this.bloqueadas = false;
      this.actualizarDialogFiltrosBloqueadas();
      this.aplicarFiltros(true);
    },
    actualizarDialogFiltrosBloqueadas() {
      if (this.$refs.dialogFiltros) {
        this.$refs.dialogFiltros.actualizarBloqueadas(this.bloqueadas);
      }
    },
  },
  computed: {
    filtrosActivos() {
      let filtros = [
        {
          value: "fechaInicio",
          text: this.fechaInicio
            ? `Fecha ini.: ${this.formatDate(this.fechaInicio)}`
            : null,
          color: "primary",
        },
        {
          value: "fechaFin",
          text: this.fechaFin
            ? `Fecha fin: ${this.formatDate(this.fechaFin)}`
            : null,
          color: "primary",
        },
        {
          value: "cliente",
          text: this.clienteSeleccionado
            ? this.clienteSeleccionado.text.length > 30
              ? `${this.clienteSeleccionado.text.substring(0, 30)}...`
              : this.clienteSeleccionado.text
            : null,
          color: "primary",
        },

        {
          value: "contrato",
          text: this.contratoSeleccionado.length ? "Contratos" : null,
          color: "primary",
        },
        {
          value: "bloqueadas",
          text: this.bloqueadas
            ? "Packs/tramos cerrados"
            : "Packs/tramos activos",
          color: this.bloqueadas ? "error" : "primary",
        },
      ];
      return filtros.filter((item) => item.text != null);
    },
  },
  created() {
    this.getPacks();
  },
};
</script>